import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { IPlatform } from 'store/type';
import styled, { css, useTheme } from 'styled-components';

import CorePictureAvatar from 'shared/avatar/CorePictureAvatar';
import { EllipsisText } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';
import round from 'utils/round';

interface IRankingProfile {
	platform: IPlatform;
	rank: number;
	profile: string;
	platform_pk?: string;
	username: string;
	biography: string;
	amount?: number | string;
	before_unit?: string;
	unit?: string;
	end_rank?: number;
	followers?: number;
}

const RankingProfile = ({
	platform,
	rank,
	profile,
	platform_pk,
	username,
	biography,
	amount,
	before_unit,
	unit,
	end_rank = 5,
	followers,
}: IRankingProfile) => {
	const theme = useTheme();
	const formattedFollowers = !followers ? '-' : `${round(followers, 'round')} ${unit}`;
	return (
		<ProfileGrid flex="between" _border={rank % end_rank !== 0 ? 'true' : 'false'}>
			<Grid flex="start" _gap="16px">
				<Text _width="9px" typo="p_bold" color={theme.colors.gray.gray80_text}>
					{rank}
				</Text>
				<Grid flex="start" _gap="8px">
					<CorePictureAvatar
						size="default"
						picture={`${profile}`}
						color_type="black"
						text="influencer"
					/>
					<Grid flex="start" direction="column" align_items="start">
						<Grid flex="start" _gap="4px">
							<EllipsisText typo="p_bold">{username}</EllipsisText>
						</Grid>
						<EllipsisText _width="100%" typo="span">
							{biography}
						</EllipsisText>
					</Grid>
				</Grid>
			</Grid>
			{followers && (
				<Text typo="span" color={theme.colors.gray.gray80_text}>
					{formattedFollowers}
				</Text>
			)}
		</ProfileGrid>
	);
};

const { Text, Grid } = style;

const ProfileGrid = styled(Grid)<{ _border: string }>`
	${({ _border, theme }) =>
		_border === 'true' &&
		css`
			border-bottom: 1px solid ${theme.colors.uplus.bg15};
		`}
	padding: 8px 8px;
	border-radius: 8px;

	transition: background-color 0.2s;
`;

const ColoredText = styled(Text)<{ bool: boolean }>`
	span {
		${({ theme }) => theme.typo.body.span};
	}
`;

export default React.memo(RankingProfile);
